import { userActions } from "../../actionTypes";

const initialState = {
	success: false,
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.REGISTER_USER: {
			return { ...state, fetching: true };
		}

		case userActions.REGISTER_USER_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				success: action.payload,
			};
		}

		case userActions.RESET_REGISTER_STATE: {
			return { ...state, ...initialState };
		}

		case userActions.REGISTER_USER_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
